import React, { useEffect, useState } from "react";
import { getList } from "../../../services/api/Api";
import { isActivePublicUser } from "../../../util/Scripts";
import SettingsModal from "../../Modal/SettingsModal";
import Widget from "../../Widget/Widget";
import WidgetCardReportSettings from "../WidgetsSettings/CardReport/CardReportSettingsModal";

const CardReport = ({ value, role = "OWNER" }) => {
   const [listData, setListData] = useState([]);
   const [columnsList, setColumnsList] = useState([]);

   useEffect(() => {
      if (value.listId != null) {
         getList(value.listId, 1, 500).then((res) => {
            const responseData = isActivePublicUser() ? res.data.getPublicList : res.data.default;
            setListData(responseData.data);
            setColumnsList(responseData.columns);
         });
      } else setListData(null);
   }, [value.listId]);
   return (
      <Widget
         styleName="gx-m-0"
         bgColor={value.backgroundColourHex}
         title={value.noteTitle}
         role={role}
         extra={
            (role === "OWNER" || role === "MODERATOR") && (
               <SettingsModal
                  widgetName={value.name}
                  widgetId={value.id}
                  icon="setting"
                  deleteIcon="true"
                  children={<WidgetCardReportSettings value={value} />}
               />
            )
         }
      >
         <div className="gx-media gx-align-items-center gx-flex-nowrap">
            <div className="gx-mr-lg-4 gx-mr-3">
               <i
                  className={`icon icon-${value.iconId} gx-fs-xlxl gx-text-${value.iconColor} gx-d-flex`}
                  style={{ fontSize: 45 }}
               />
            </div>
            <div className="gx-media-body">
               <h1
                  className="gx-fs-xxxl gx-font-weight-medium gx-mb-1"
                  style={{ color: value.textColor }}
               >
                  {value.title}
               </h1>
               <p className="gx-text-blue gx-mb-1" style={{ color: value.textColor, fontSize: 20 }}>
                  {listData ? listData.length : "0"}
               </p>
            </div>
         </div>
      </Widget>
   );
};

export default CardReport;
